import { Grid } from "@mui/material";
import React from "react";
import "../assets/styles/feddback.css";
import companyLogo from "../assets/image/ark.png";
import companyBG from "../assets/image/companiesBG.jpg";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
const Feedback = () => {
  return (
    <div className="feedback_container">
      <div className="feedback_content">
        <div className="feedback_title">
          <p>Companies I've had worked</p>
        </div>
        <Grid container>
          <Grid item xs={12} md={3}></Grid>
          <Grid item xs={12} md={6}>
            <div className="companies">
              <div className="companies_bg">
                <img src={companyBG} alt="companyBG" />
              </div>
              <div className="companies_logo">
                <img src={companyLogo} alt="companyLogo" />
              </div>
              <div className="companies_details">
                <div className="companies_info">
                  <p>ARK Software Inc.</p>
                  <p style={{ marginLeft: "0px", marginTop: "11px" }}>
                    <span style={{ marginRight: "10px" }}>
                      <FmdGoodIcon />
                    </span>
                    Dhaka
                  </p>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={3}></Grid>
          <Grid item xs={12} md={1}></Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Feedback;
